// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailR":"R_d2xDetailR__51U_x"};